import { Link } from 'gatsby';

type LinkProps = {
    children: never;
    datawalink: string;
    link: string;
    linkqa: string;
    linktext: string;
    useinnerblock: false;
};

type InnerBlockProps = React.PropsWithChildren<{
    datawalink: never;
    link: never;
    linkqa: never;
    linktext: never;
    useinnerblock: true;
}>;

type Props = {
    title: string;
    img: string;
    imgalt: string;
    titlesize?: string;
} & (LinkProps | InnerBlockProps);

const MidContentCta = ({
    children,
    datawalink,
    img,
    imgalt,
    link = '/',
    linkqa,
    linktext,
    title,
    titlesize = '',
    useinnerblock,
}: Props) => {
    return (
        <div className="bg-blue-pink min-h-28 rounded-md shadow blue-pink-gradient flex items-center mb-8 print:hidden">
            <div className="w-28">
                <img className="object-cover rounded-l-md shadow" src={img} alt={imgalt} />
            </div>
            <div className="p-3 md:p-4">
                <div className={`md:font-semibold text-black text-${titlesize} mb-1 md:mb-2`}>
                    {title}
                </div>
                {useinnerblock ? (
                    <div className="grid grid-cols-2 gap-3">{children}</div>
                ) : (
                    <Link
                        className="font-semibold text-base text-link"
                        to={link}
                        data-wa-link={datawalink}
                        data-qa={linkqa}
                    >
                        {linktext}
                    </Link>
                )}
            </div>
        </div>
    );
};

export default MidContentCta;
